import { render, staticRenderFns } from "./PaymentPlans.vue?vue&type=template&id=53060457&"
import script from "./PaymentPlans.vue?vue&type=script&lang=js&"
export * from "./PaymentPlans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3289102252/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53060457')) {
      api.createRecord('53060457', component.options)
    } else {
      api.reload('53060457', component.options)
    }
    module.hot.accept("./PaymentPlans.vue?vue&type=template&id=53060457&", function () {
      api.rerender('53060457', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/welcome/actionItems/PaymentPlans.vue"
export default component.exports